export default __webpack_public_path__ + "static/media/480_business03-es-web.a9f28bf2.png";